// extracted by mini-css-extract-plugin
module.exports = {"container":"TagMonster_container__3GaBn","segmentedContainer":"TagMonster_segmentedContainer__3hxCI","content":"TagMonster_content__MlhLO"};